import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'selectRoleFilter',
    pure: false
})
export class SelectRoleFilterPipe implements PipeTransform {
    public transform(items: any[], site: string): any {
        const out = [];
        console.log('SelectRoleFilterPipe-site: '+ site);
        if (site === undefined) {
            items.forEach(function (item) {
                if (item.notSiteSpecific === true) {
                    out.push(item);
                }
            });
        } else {
            items.forEach(function (item) {
                if (item.notSiteSpecific === false) {
                    out.push(item);
                }
            });
        }
        console.log('SelectRoleFilterPipe-out: '+ out.length);
        return out;
    }
}
